import { type ReactNode } from 'react';
import { Loader2 } from 'lucide-react';
import { SubscriptionType } from '@/lib/api/routingApi';
import { useRoutingUserDetails } from '@/hooks/useRoutingUserDetails';
import AccessKeyPage from '@/pages/AccessKeyPage';

interface VerifiedGateProps {
  children: ReactNode;
}

export function VerifiedGate({ children }: VerifiedGateProps): React.JSX.Element {
  const { data, isLoading, isError } = useRoutingUserDetails();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="size-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (isError || !data || data.subscription !== SubscriptionType.Pro) {
    return <AccessKeyPage />;
  }

  return <>{children}</>;
}
